import promptopia_image from "../promtopia_image.png";

const projects = [
  {
    order: 0,
    imgSrc: promptopia_image,
    name: "Promtopia",
    desc: " Donec euismod felis non est hendrerit, in fermentum quam\n      hendrerit. Etiam tristique blandit velit.\n    ,",
    gitLink: "https://github.com/rstudy211/project_promtopia",
    techStack: [
      {
        name: "Next.js",
        icon: "fab fa-react fa-3x"
      },
      {
        name: "Node.js",
        icon: "fab fa-node fa-3x"
      },
      {
        name: "MongoDB",
        icon: "fas fa-database fa-3x"
      }
    ]
  },
  {
    order: 1,
    imgSrc: "https://raw.githubusercontent.com/rstudy211/Chat-App/5d89e2bb82d3fa24079e19566630e1a668db1caa/Screenshot%202023-02-22%20at%202.41.52%20PM.png",
    name: "Chat-App",
    desc: "Chat-App is a React-based application that allows users to chat\n      with each other in real-time. The app includes features such as\n      the ability to create chat rooms, invite users to join a chat,\n      and send text messages.",
    gitLink: "https://github.com/rstudy211/Chat-App",
    techStack: [
      {
        name: "React.js",
        icon: "fab fa-react fa-3x"
      },
      {
        name: "Java",
        icon: "fab fa-java fa-3x"
      },
      {
        name: "MongoDB",
        icon: "fas fa-database fa-3x"
      }
    ]
  },
  {
    order: 1,
    imgSrc: "https://raw.githubusercontent.com/rstudy211/Blog-App/main/Frontend(React)/src/Images/Screenshot%202023-04-07%20at%2010.09.49%20PM.png",
    name: "Blog-App",
    desc: "The Blog App is a React-Spring Boot web application that allows\n      users to create, read, update and delete blog posts. It uses\n      MySQL to store the blog posts and provides features such as user\n      account management, post search, filtering and sorting.\n    ,",
    gitLink: "https://github.com/rstudy211/Blog-App",
    techStack: [
      {
        name: "React.js",
        icon: "fab fa-react fa-3x"
      },
      {
        name: "Java",
        icon: "fab fa-java fa-3x"
      },
      {
        name: "Mysql",
        icon: "fas fa-database fa-3x"
      }
    ]
  },
  {
    order: 2,
    imgSrc: "https://raw.githubusercontent.com/rstudy211/TodoApp/main/Screenshot%202022-09-24%20at%2011.58.52%20PM.png",
    name: "Todo-App",
    desc: "A Node.js, Express, and MongoDB-based todo app is a web tool for\n      managing daily tasks. Users can add, update, or delete tasks,\n      which are stored in a MongoDB database, and use search and\n      filter options to organize and find their tasks.\n    ,",
    gitLink: "https://github.com/rstudy211/TodoApp",
    techStack: [
      {
        name: "Node.js",
        icon: "fab fa-node fa-3x"
      },
      {
        name: "Express.js",
        icon: "fas fa-server fa-3x"
      },
      {
        name: "Mysql",
        icon: "fas fa-database fa-3x"
      }
    ]
  },
  {
    order: 1,
    imgSrc: "https://github.com/rstudy211/DigiCarda/raw/main/Screenshot%202023-03-20%20at%205.16.10%20PM.png",
    name: "DigiCarda",
    desc: " Donec euismod felis non est hendrerit, in fermentum quam\n      hendrerit. Etiam tristique blandit velit.\n    ,",
    gitLink: "https://github.com/rstudy211/DigiCarda",
    techStack: [
      {
        name: "React.js",
        icon: "fab fa-react fa-3x"
      },
      {
        name: "Mysql",
        icon: "fas fa-database fa-3x"
      }
    ]
  },
  
]

export default  projects;